namespace nsc {
    window.addEventListener("hashchange", route);

    function route() {
        let target = location.hash ? location.hash.substr(1) : "form";

        if (target === "quick") {
            target = "form";
        }

        if (target !== "complete" && target !== "form") {
            location.replace(location.pathname);
            target = "form";
        }

        nsc.activateWizardPage("#brokers-" + target);

        if (location.hash === "#quick") {
            const $quickEmail = $("#broker-quick-email");
            const noteHolder = sessionStorage.getItem("noteHolder");

            if (noteHolder !== null) {
                try {
                    prepopulateBrokerForms(JSON.parse(noteHolder));
                } catch (error) {
                    // Ignore JSON parse errors
                }
            }

            $quickEmail.focus();
        }
    }

    $("input[name='ReferralID']").val(nsc.getReferralId());

    route();

    function displayThankYouPage() {
        const email = $("input[name='Partner_Email']").val() as string;

        $("#broker-email").text(email);

        let targetUrl: string;

        if (nsc.getCookie("BrokerRFQ")) {
            $(".resume-quote").removeClass("d-none");
            targetUrl = "/sanbox/BrokerWorksheet.cfm";
        } else {
            $(".submit-quote").removeClass("d-none");
            targetUrl = "quote#screen1";
        }

        $("#request-quote").attr("href", targetUrl);

        sendGoogleAnalyticsEvent("m_broker_signup", "Broker");

        location.replace("#complete");
    }

    $("#broker-registration").on("submit", function (this: HTMLFormElement) {
        postForm(this, "/BrokerAction.cfm").then(displayThankYouPage);
    });

    jQuery.validator.addMethod("registered", function (value: any, element: HTMLElement) {
        return element.dataset.unknownEmail !== "true";
    }, "No match found, please enter a registered email address.");


    const $brokerQuickForm = $("#broker-quick");

    $brokerQuickForm.validate({
        rules: {
            BrokerQuickEmail: {
                required: true,
                email: true,
                registered: true
            }
        }
    });


    function onBrokerQuickSubmit(this: HTMLFormElement, event: JQueryEventObject) {
        event.preventDefault();

        const $input = $(this.elements[0]);

        $input.removeAttr("data-unknown-email");

        if (!$brokerQuickForm.valid()) {
            return;
        }

        const $button = $("button", this);

        $button.attr("disabled", "");

        const email = String($input.val()).toLowerCase();

        const url = "/api/broker?email=" + encodeURIComponent(email);
        const xhr = $.getJSON(url);

        xhr.always(() => $button.removeAttr("disabled"));

        xhr.then((data: any) => {
            if (data.email !== email) {
                $input.attr("data-unknown-email", "true");
                $brokerQuickForm.validate().form();
                return;
            }

            sendGoogleAnalyticsEvent("m_broker_quick_login", {
                event_category: "Broker",
                event_callback: () => {
                    // ColdFusion serializes phone numbers as integers, so turn them
                    // back into strings here.
                    data.cellPhone = String(data.cellPhone);
                    data.phone = String(data.phone);

                    // Store the broker data in session storage for RFQ screen 1
                    sessionStorage.setItem("broker", JSON.stringify(data));

                    location.href = "quote#screen1";
                }
            });
        });
    }

    $brokerQuickForm.on("submit", onBrokerQuickSubmit).validate();

    function prepopulateBrokerForms(noteHolder: BrokerInformation) {
        const data: { [prop: string]: string } = {
            "Partner_Firstname": noteHolder.firstName,
            "Partner_Lastname": noteHolder.lastName,
            "Partner_Email": noteHolder.email,
            "_ConfirmEmail": noteHolder.email,
            "Partner_Phone": noteHolder.phone,
            "Partner_Cell_Evening": noteHolder.cellPhone,
            "Partner_Company": noteHolder.company,
            "Partner_Address1": noteHolder.address1,
            "Partner_Address2": noteHolder.address2,
            "Partner_Address3": noteHolder.address3,
            "Partner_City": noteHolder.city,
            "Partner_State": noteHolder.state,
            "Partner_Zip": noteHolder.zip,
            // "BrokerQuickEmail": noteHolder.email
        };

        for (const name of Object.keys(data)) {
            const $input = $(`:input[name='${name}']`);
            const value = data[name];

            if ($input.length > 1 && $input.first().hasClass("tt-hint")) {
                $input.filter(".tt-input").typeahead("val", states[value]);
            } else {
                $input.val(value);
            }

            if ($input.prop("type") === "tel") {
                $input.trigger("change");
            }
        }
    }
}